import { Component, OnInit, ViewChild, ViewEncapsulation,Input } from '@angular/core';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';
import { CookieService } from 'ngx-cookie-service';
import { HomepageService } from '../../../services/homepage.service';
const now = new Date();
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EventsComponent implements OnInit {
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
  @Input() buId: number;
  years: number =  now.getFullYear();
  month: number = now.getMonth()+1;
  closedDays: any[] = []; 
  openDays: any[] = []; 
  calendarOptions: Options;
  eventsList: any = []; 
  eventsEnableList: object = []; 
  widgetsSetting: any = [];
  isResponse: boolean = false;   
  messageInfo: string;
  dateFormat:string = "M/d/yyyy";
  eventTitle:string = '';
  eventDescription:string = '';
  eventDate:string = '';
  eventEndDate:string = '';
  eventLink:string = '';
  eventForDetails:any = [];
  showDetailsCalendar = false;
  checkChangedEvent:string = '';
  locationName:string = '';
  constructor(private cookieService: CookieService, private homepageService: HomepageService ) {}
  ngOnInit() {
    this.getEvents();
    this.locationName = location.origin;
  }

  
  getEvents() {
    this.dateFormat = this.homepageService.formatDate();
    var lists =  [];
    let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
    getwidgetsSettingDataSave.data.forEach(evts => {
      if(evts.code == 'CA' && this.buId  == evts.id){
        if(typeof(evts.settings.message) != 'undefined'){
            this.messageInfo = evts.settings.message;
        }
        this.eventsList = evts.content;              
      }            
    });
    var i = 0;
    this.cookieService.set('events', JSON.stringify(this.eventsList.events));
    this.closedDays = this.eventsList.closedDates;
    this.eventsList.events.forEach(evt => {
      if(evt.closed === true){
        //this.closedDays[i] = evt.date; 
      } else {
        this.openDays[i] = evt.date;          
      }
      let getEndDate = new Date(evt.endDate);
      let endDate = getEndDate.setDate(getEndDate.getDate()+1);
      lists[i] = {'title': evt.name,'start' : evt.date, 'end': endDate, "color" : "pink", 'allDay' : false,'textColor' : 'white'}              
      i++;
    });     
    this.eventsEnableList = lists;              
    this.calendarOptions = {
      editable: true,
      timezone: 'UTC',
      eventLimit: false,
      showNonCurrentDates: false,
      header: {
        left: 'prev',
        center: 'title',
        right: 'next'
      },
      events: lists
    };
    this.isResponse = true;        
  }


  clickButton(data){
    this.isResponse = false;
    var lists =  [];
    var colorinfo = "";
    var extractDate = new Date(data.data);
    this.years =  extractDate.getUTCFullYear();
    this.month =  extractDate.getUTCMonth()+1;
    return this.homepageService.getEvents(this.years,this.month).subscribe((data) => { 
      var i = 0;
      this.closedDays = data.data.closedDates;
      this.cookieService.set('events', JSON.stringify(data.data.events));
      data.data.events.forEach(evt => {
        //console.log('events', evt);
        if(evt.closed === true){
          //this.closedDays[i] = evt.date;
        } else {
          this.openDays[i] = evt.date;          
        }
        let getEndDate = new Date(evt.endDate);
        let endDate = getEndDate.setDate(getEndDate.getDate()+1);
        if(evt.date == evt.endDate ){
          lists[i] = {'title': evt.name,'description': evt.description,'start' : evt.date, "color" : "pink", 'allDay' : false,'textColor' : 'white'}
        }else{
          lists[i] = {'title': evt.name,'description': evt.description,'start' : evt.date, 'end' : endDate, "color" : "pink", 'allDay' : false,'textColor' : 'white'}
        }
        i++;
      });
      this.eventsList = data.data;
      this.eventsEnableList = lists;
      this.ucCalendar.renderEvents(lists);    
      this.closedDays.forEach(evt => {
        //console.log("Closed Day", evt);
        var today1 = new Date(evt);
        var cDate1 = today1.getDate().toString();
        if(parseInt(cDate1) < 10){
          cDate1 = "0"+cDate1;
        }
        var cMonth1 = (today1.getMonth() + 1).toString();
        if(parseInt(cMonth1) < 10){
          cMonth1 = "0"+cMonth1;
        }
        var cYear1 = today1.getFullYear();
        var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
        $('td[data-date="'+rDate1+'"]').addClass('disabledDay');
      });
      this.openDays.forEach(evt => {
        var today1 = new Date(evt);
        var cDate1 =   today1.getDate().toString();
        if(parseInt(cDate1) < 10){
          cDate1 = "0"+cDate1;
        }
        var cMonth1 = (today1.getMonth() + 1).toString();
        if(parseInt(cMonth1) < 10){
          cMonth1 = "0"+cMonth1;
        }
        var cYear1 = today1.getFullYear();
        var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
        $('td[data-date="'+rDate1+'"]').addClass('openDay');
      });
      this.isResponse = true;
    });
  }

  dayRender(date){
    this.closedDays.forEach(evt => {
      var today1 = new Date(evt);
      var cDate1 =   today1.getDate().toString();
      if(parseInt(cDate1) < 10){
        cDate1 = "0"+cDate1;
      }
      var cMonth1 = (today1.getMonth() + 1).toString();
      if(parseInt(cMonth1) < 10){
        cMonth1 = "0"+cMonth1;
      }
      var cYear1 = today1.getFullYear();
      var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
      $('td[data-date="'+rDate1+'"]').addClass('disabledDay');
    });
    this.openDays.forEach(evt => {
      var today1 = new Date(evt);
      var cDate1 =   today1.getDate().toString();
      if(parseInt(cDate1) < 10){
        cDate1 = "0"+cDate1;
      }
      var cMonth1 = (today1.getMonth() + 1).toString();
      if(parseInt(cMonth1) < 10){
        cMonth1 = "0"+cMonth1;
      }
      var cYear1 = today1.getFullYear();
      var rDate1 =  cYear1+'-'+cMonth1+'-'+cDate1;
      $('td[data-date="'+rDate1+'"]').addClass('openDay');
    });
    var weekdays = [0,1, 2, 3, 4, 5,6];        
    weekdays.forEach(evt => {
      var isHave = this.eventsList.closedDaysOfWeek.indexOf(evt);
      if(isHave >= 0){
        $('.fc-content-skeleton').find('thead tr td:eq('+evt+')').addClass('closeDays');
      }
    });
  }

  eventClick(detail){
    if(this.cookieService.check('events')){
      var events = JSON.parse(this.cookieService.get('events'));
      //console.log(events);
      var eventToShow = [];
      events.forEach((val,key)=>{
      //console.log(detail.event.start._i,  val.date);
        if(detail.event.start._i == val.date){
          eventToShow.push(val);
        }
      });
      this.eventForDetails = eventToShow;
      //console.log(this.eventForDetails);
      this.eventDescription = this.eventForDetails[0].description;
      this.eventLink = this.eventForDetails[0].bulletinId;
      this.showDetailsCalendar = true;
      //console.log(this.eventForDetails);
    }else{
      this.eventForDetails = [];
    }
  }

  showDetails(description, title, date, endDate, link = ''){
    this.eventTitle = title;
    console.log("show details"+ description);
    this.eventDescription = description;
    this.eventDate = date;
    this.eventEndDate = endDate
    this.eventLink = link;
    //$('#calendarDetail').addClass('show in').show();
  }

  hideDetailsCalendar(){
    this.showDetailsCalendar = false;
  }

  currentEvent(event:any){
    var tempIdCal:any = $(event.target).val();
    this.eventDescription = this.eventForDetails[tempIdCal].description;
    this.eventLink = this.eventForDetails[tempIdCal].bulletinId;

  }

}